import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/forgot-password";
import { buildNoindexHead } from "@/lib/noindex-seo";

export const Route = createFileRoute("/forgot-password")({
  head: () => buildNoindexHead("Reset Your Password", "/forgot-password"),
  component: Page,
});
